import MonthlyStatementReduxModel from 'src/model/modules/monthlyStatement.model';
import MonthlyStatementModel from 'src/model/monthlyStatement.model';

const MonthlyStatementSel = (state: any): MonthlyStatementReduxModel =>
  state.monthlyStatement;

export const contentSel = (state: any): MonthlyStatementModel =>
  MonthlyStatementSel(state).content;
export const getMonthlyStatementIsPending = (state: any): boolean =>
  MonthlyStatementSel(state).getMonthlyStatementIsPending;
export const getMonthlyStatementError = (
  state: any
): {
  caller: string;
  error: any;
} => MonthlyStatementSel(state).error;
